import styled from 'styled-components'
import { geoZoneToolTipLamdaBySize, geoZoneToolTipLamdaBySizeMonitoring, geoZoneToolTipLamdaBySizePassportization } from '@/constants/maps'
import {
  MARKS_COLORS,
} from '@/constants/styles/mapsMarks'

export const ElementContainer = styled.div`
  height: 18px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 0px 10px;
  .svgFill,
  .svgFill {
    height: 18px;
    width: 18px;
  }
  ${({ isPassportization }) => isPassportization && `
    justify-content: center
  `}
`

export const IconContainer = styled.div`
  height: 18px;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Container = styled.div`
  padding: 17px 5px 17px 5px;
  width: 220px;
  position: absolute;
  top: ${({ type, isMonitoring, isPassportization }) => {
    if (isMonitoring) {
      return geoZoneToolTipLamdaBySizeMonitoring[type].top
    }
    if (isPassportization){
      return geoZoneToolTipLamdaBySizePassportization[type].top
    }
    return geoZoneToolTipLamdaBySize[type].top
  }}px;
  left: ${({ type }) => geoZoneToolTipLamdaBySize[type].left}px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  background: ${({ theme }) => theme.colors.backgrounds.default};
  z-index: 100;
  ${ElementContainer}:not(:first-child){
    margin-top: 5px;
  }
  ${ElementContainer}:not(:last-child){
    margin-bottom: 5px;
  }
  cursor: pointer;
  z-index: 9999;
  box-shadow: 2px 2px 10px 0 rgba(0,0,0,0.4);

`

export const ShadowShalfe = styled.div`
  width: 220px;
  height: 100%;
  position: absolute;
  top: ${({ type, isMonitoring }) => isMonitoring ? geoZoneToolTipLamdaBySizeMonitoring[type].top : geoZoneToolTipLamdaBySize[type].top}px;
  left: ${({ type }) => geoZoneToolTipLamdaBySize[type].left}px;
  border-radius: 4px;
  z-index: 90;
  box-shadow: 2px 2px 10px 0 rgba(0,0,0,0.4);
`

export const Tip = styled.div`
  width: 12px;
  height: 12px;
  position: absolute;
  top: ${({ type }) => geoZoneToolTipLamdaBySize[type].tip.top}px;
  left: ${({ type }) => geoZoneToolTipLamdaBySize[type].tip.left}px;
  background: ${({ theme }) => theme.colors.backgrounds.default};
  transform: rotate(45deg);
  z-index: 95;
  box-shadow: 2px 4px 10px 0 rgba(0,0,0,0.4);
`

export const ElementMark = styled.div`
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: ${({ type }) => MARKS_COLORS[type]};
`

export const ElementTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5rem;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colors.colors.redisign.default};
  white-space: pre-wrap;
  text-align: left;
  margin-left: 10px;
   ${({ primary }) => primary && `
    font-size: 1.4rem;
  `}
`
